export default "__VITE_ASSET__VAjI2r$8__ 778w";